<template>
  <select-family :config="config"
                 @input="handleInput"
                 :value="selected"/>
</template>

<script>
/* globals route axios */

import SelectFamily from '../families/FamilySelect.vue';
import filter from '../../mixins/filter';

export default {
  mixins: [filter],

  components: { SelectFamily },

  computed: {
    config() {
      return {
        'allow-empty': true,
        multiple: this.multiple,
        closeOnSelect: false,
        clearOnSelect: false,
        defaultOptions: [{ id: 'null', name: 'Sans Famille' }],
      };
    },
  },

  data() {
    return {
      selected: [],
    };
  },

  methods: {
    setSelected() {
      this.selected = [];
      const params = this.getParam();

      if (!params) {
        return;
      }

      if (params.includes('null')) {
        this.selected = [this.config.defaultOptions[0]];
      }

      axios
        .get(`${route('api.families.index')}?families=${params}`)
        .then(({ data }) => {
          this.selected = [...this.selected, ...data.data];
        })
        .catch(() => {
          this.selected = [];
        });
    },
  },
};
</script>
